import { useState, useRef, useEffect } from "react";
import Button from "../Button/Button";
import SingleAccount from "../Accounts/SingleAccount";
import Editor from "../Editor/Editor/Editor";
import Message from "../Chat/Message";
import Settings from "../Settings/Settings";
import "./accounts.css";
import axios from "axios";
import { useGlobalContext } from "../Context/Context";
import TrustFolder from "../TrustFolder/TrustFolder";
import HomePage from "../HomePage/HomePage";
import Link from "../Links/Link";
import LanguageApp from "../LanguagePage/LanguageApp/LanguageApp";
import LinksItemModal from "../LinksItemModal/LinksItemModal";
import Profile from "../Profile/Profile";
import ProfileExternal from "../ProfileExternal/ProfileExternal";
import AdminPanelHome from "../AdminPanel/AdminPanelHome";
import Notification from "../AdminPanel/Component/Notification/Notification";

const Accounts = ({
  selectAccount,
  setSelectAccount,
  setSelectAccountPin,
  setCurrentPageGlobal,
}) => {
  const { baseUrl } = useGlobalContext();
  const { loggedUser } = useGlobalContext();
  const { apiKey } = useGlobalContext();
  const { boldItalic } = useGlobalContext();

  const [accounts, setAccounts] = useState([]);
  const [locations, setLocations] = useState([]);
  const { account, setAccount } = useGlobalContext();
  const { setLocation } = useGlobalContext();
  const [checkBack, setCheckBack] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { typeButton } = useGlobalContext();
  const { letterSize } = useGlobalContext();
  const { fontSize } = useGlobalContext();
  const { fontStyle } = useGlobalContext();
  const { location } = useGlobalContext();

  const handleAccount = async (item) => {
    if (item.id === 7) {
      window.location.href = "https://www.google.com";
      return;
    }
    setAccount(item);
    try {
      const { data } = await axios.post(
        `${baseUrl}/companies/getUserLocationsByCompanyId.php`,
        {
          user_id: loggedUser.id,
          api_key: apiKey,
          company_id: item.id,
        }
      );
      if (data.status === 200) {
        setSelectAccount(2);
        setLocations(data.locations);
      }
    } catch (data) {
      console.log(data);
    }
  };

  const handleChooseLocation = (location) => {
    setSelectAccount(3);
    setLocation(location);
  };

  const handleConvertText = (text) => {
    if (letterSize === undefined || letterSize === null) return text;
    if (letterSize === 0) return text.toUpperCase();
    if (letterSize === 1) return text[0].toUpperCase() + text.slice(1).toLowerCase();
    if (letterSize === 2) return text.toLowerCase();
  };

  useEffect(() => {
    const handleAccountData = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/companies/getCompaniesByUserId.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
          }
        );
        if (data.status === 200) {
          setAccounts(data.companies);
          setSelectAccount(16);
        }
      } catch (data) {}
      setIsLoading(false);
    };

    handleAccountData();
  }, []);

  if (isLoading) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}>
        <div style={{
          width: "48px",
          height: "48px",
          border: "5px solid #e0e0e0",
          borderTop: "5px solid #555",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <>
      {(selectAccount === 2 || selectAccount === 1 || selectAccount === 6) && (
        <div className="accounts-wrapper">
          {selectAccount === 2 && (
            <SingleAccount
              setSelectAccount={setSelectAccount}
              selectAccount={selectAccount}
              locations={locations}
            />
          )}
          {selectAccount === 1 && (
            <div className="wrapper-location">
              <div
                className={
                  "name-account " +
                  `font-size-${parseInt(fontSize === undefined || fontSize === null ? 0 : fontSize / 3)}` +
                  ` font-style-${parseInt(fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3)}`
                }
                style={
                  boldItalic.find((element) => parseInt(element) === 2) !== undefined
                    ? { fontWeight: "normal", fontStyle: "normal" }
                    : boldItalic.find((element) => parseInt(element) === 1) !== undefined &&
                      boldItalic.find((element) => parseInt(element) === 0) !== undefined
                    ? { fontWeight: "bold", fontStyle: "italic" }
                    : boldItalic.find((element) => parseInt(element) === 0) !== undefined
                    ? { fontStyle: "italic" }
                    : boldItalic.find((element) => parseInt(element) === 1) !== undefined
                    ? { fontWeight: "bold" }
                    : { fontWeight: "normal", fontStyle: "normal" }
                }
              >
                {handleConvertText(account.name.toUpperCase())}
              </div>
              <div className="concret-location">
                {locations.map((location) => (
                  <div
                    className="location-name"
                    onClick={() => handleChooseLocation(location)}
                  >
                    <Button typeButton={typeButton} activation={true}>
                      <div
                        className={
                          "location-name-current " +
                          `font-size-${parseInt(fontSize === undefined || fontSize === null ? 0 : fontSize / 3)}` +
                          ` font-style-${parseInt(fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3)}`
                        }
                        style={
                          boldItalic.find((element) => parseInt(element) === 2) !== undefined
                            ? { fontWeight: "normal", fontStyle: "normal" }
                            : boldItalic.find((element) => parseInt(element) === 1) !== undefined &&
                              boldItalic.find((element) => parseInt(element) === 0) !== undefined
                            ? { fontWeight: "bold", fontStyle: "italic" }
                            : boldItalic.find((element) => parseInt(element) === 0) !== undefined
                            ? { fontStyle: "italic" }
                            : boldItalic.find((element) => parseInt(element) === 1) !== undefined
                            ? { fontWeight: "bold" }
                            : { fontWeight: "normal", fontStyle: "normal" }
                        }
                      >
                        {handleConvertText(location.location_name)}
                      </div>
                    </Button>
                  </div>
                ))}
              </div>
              <div
                className={
                  "logo-account " +
                  `font-size-${parseInt(fontSize === undefined || fontSize === null ? 0 : fontSize / 3)}` +
                  ` font-style-${parseInt(fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3)}`
                }
                style={
                  boldItalic.find((element) => parseInt(element) === 2) !== undefined
                    ? { fontWeight: "normal", fontStyle: "normal" }
                    : boldItalic.find((element) => parseInt(element) === 1) !== undefined &&
                      boldItalic.find((element) => parseInt(element) === 0) !== undefined
                    ? { fontWeight: "bold", fontStyle: "italic" }
                    : boldItalic.find((element) => parseInt(element) === 0) !== undefined
                    ? { fontStyle: "italic" }
                    : boldItalic.find((element) => parseInt(element) === 1) !== undefined
                    ? { fontWeight: "bold" }
                    : { fontWeight: "normal", fontStyle: "normal" }
                }
              >
                {account.logo === "" ? (
                  handleConvertText(account.name[0].toUpperCase())
                ) : (
                  <img src={account.logo} alt="" />
                )}
              </div>
            </div>
          )}
          {selectAccount === 6 && (
            <div className="account-list">
              {accounts.map((item, index) => (
                <div
                  className="account"
                  onClick={() => handleAccount(item)}
                  key={index}
                >
                  <Button typeButton={typeButton}>
                    {item.logo === "" ? (
                      <div
                        className={
                          "account-button " +
                          `font-size-${parseInt(fontSize === undefined || fontSize === null ? 0 : fontSize / 3)}` +
                          ` font-style-${parseInt(fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3)}`
                        }
                      >
                        <span
                          className={
                            "initial " +
                            `font-size-${parseInt(fontSize === undefined || fontSize === null ? 0 : fontSize / 3)}` +
                            ` font-style-${parseInt(fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3)}`
                          }
                          style={
                            boldItalic.find((element) => parseInt(element) === 2) !== undefined
                              ? { fontWeight: "normal", fontStyle: "normal" }
                              : boldItalic.find((element) => parseInt(element) === 1) !== undefined &&
                                boldItalic.find((element) => parseInt(element) === 0) !== undefined
                              ? { fontWeight: "bold", fontStyle: "italic" }
                              : boldItalic.find((element) => parseInt(element) === 0) !== undefined
                              ? { fontStyle: "italic" }
                              : boldItalic.find((element) => parseInt(element) === 1) !== undefined
                              ? { fontWeight: "bold" }
                              : { fontWeight: "normal", fontStyle: "normal" }
                          }
                        >
                          {handleConvertText(item.name[0].toUpperCase())}
                        </span>
                        <span
                          className={
                            `font-size-${parseInt(fontSize === undefined || fontSize === null ? 0 : fontSize / 3)}` +
                            ` font-style-${parseInt(fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3)}`
                          }
                          style={
                            boldItalic.find((element) => parseInt(element) === 2) !== undefined
                              ? { fontWeight: "normal", fontStyle: "normal" }
                              : boldItalic.find((element) => parseInt(element) === 1) !== undefined &&
                                boldItalic.find((element) => parseInt(element) === 0) !== undefined
                              ? { fontWeight: "bold", fontStyle: "italic" }
                              : boldItalic.find((element) => parseInt(element) === 0) !== undefined
                              ? { fontStyle: "italic" }
                              : boldItalic.find((element) => parseInt(element) === 1) !== undefined
                              ? { fontWeight: "bold" }
                              : { fontWeight: "normal", fontStyle: "normal" }
                          }
                        >
                          {handleConvertText(item.name.toUpperCase())}
                        </span>
                      </div>
                    ) : (
                      <div className="account-button">
                        <img className="account-button-image" src={item.logo} alt="" />
                        <span
                          className={
                            `font-size-${parseInt(fontSize === undefined || fontSize === null ? 0 : fontSize / 3)}` +
                            ` font-style-${parseInt(fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3)}`
                          }
                          style={
                            boldItalic.find((element) => parseInt(element) === 2) !== undefined
                              ? { fontWeight: "normal", fontStyle: "normal" }
                              : boldItalic.find((element) => parseInt(element) === 1) !== undefined &&
                                boldItalic.find((element) => parseInt(element) === 0) !== undefined
                              ? { fontWeight: "bold", fontStyle: "italic" }
                              : boldItalic.find((element) => parseInt(element) === 0) !== undefined
                              ? { fontStyle: "italic" }
                              : boldItalic.find((element) => parseInt(element) === 1) !== undefined
                              ? { fontWeight: "bold" }
                              : { fontWeight: "normal", fontStyle: "normal" }
                          }
                        >
                          {handleConvertText(item.name.toUpperCase())}
                        </span>
                      </div>
                    )}
                  </Button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {selectAccount === 4 && (
        <Settings
          selectAccount={selectAccount}
          setSelectAccountPin={setSelectAccountPin}
        />
      )}
      {selectAccount === 5 && (
        <Message
          checkBack={checkBack}
          setCheckBack={setCheckBack}
          currentTab={setSelectAccountPin}
          isExternalChat={true}
        />
      )}
      {selectAccount === 14 && (
        <ProfileExternal setSelectAccount={setSelectAccount} />
      )}
      {selectAccount === 15 && (
        <Message
          checkBack={checkBack}
          setCheckBack={setCheckBack}
          currentTab={setSelectAccountPin}
          isExternalChat={false}
        />
      )}
      {selectAccount === 0 && (
        <HomePage
          setSelectAccount={setSelectAccount}
          setCurrentPage={setCurrentPageGlobal}
        />
      )}
      {selectAccount === 3 && (
        <Editor
          setSelectAccount={setSelectAccount}
          account={account}
          location={location}
        />
      )}
      {selectAccount === 13 && (
        <Link
          setSelectAccount={setSelectAccount}
          currentTab={setSelectAccountPin}
          setCheckBack={setCheckBack}
        />
      )}
      {selectAccount === 12 && (
        <Profile setSelectAccount={setSelectAccount} />
      )}
      {selectAccount === 10 && (
        <LanguageApp
          setCurrentPageGlobal={setCurrentPageGlobal}
          setSelectAccount={setSelectAccount}
        />
      )}
      {selectAccount === 16 && (
        <AdminPanelHome account={account} setSelectAccount={setSelectAccount} />
      )}
      {selectAccount === 17 && (
        <Notification selectedCompany={{ company_id: null }} />
      )}
    </>
  );
};

export default Accounts;